module.exports = __webpack_public_path__ + "media/src/images/site-top/icon-toyama-sm-96c875ec69ea1966e5f6bb58ca938a40.png";